import React from 'react';
import { Form, Col } from 'react-bootstrap';
import Select from 'react-select';

import { COUNTRIES, getRegionsForCountry, getCountryConfig, getCountry, getRegion, SELECT_STYLES } from './regions';
import { SubSectionHeader, Label, Checkbox } from './styles';

const OrderAddress = ({
  register,
  defaultValues,
  errors,
  clearErrors,
  setValue,
  withEssentials,
  sameAddress,
  handleSameAddress,
  handleDeliveryRegionSelect,
  handleBillingRegionSelect,
  deliveryCountry,
  billingCountry,
  handleDeliveryCountrySelect,
  handleBillingCountrySelect,
  deliveryRegion,
  billingRegion,
}) => {
  const deliveryConfig = getCountryConfig(deliveryCountry);
  const billingConfig = getCountryConfig(billingCountry);

  return (
    <>
      {withEssentials && (
        <>
          <SubSectionHeader>
            <Label>Delivery Address</Label>
          </SubSectionHeader>

          <Form.Row>
            <Form.Group as={Col} controlId="line1">
              <Form.Label>Street</Form.Label>
              <Form.Control
                name="delivery.line1"
                type="text"
                ref={register({ required: true })}
                isInvalid={!!errors?.delivery?.line1}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="line2">
              <Form.Label>Suburb</Form.Label>
              <Form.Control
                name="delivery.line2"
                type="text"
                ref={register}
                isInvalid={!!errors?.delivery?.line2}
              />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="city">
              <Form.Label>City</Form.Label>
              <Form.Control
                name="delivery.city"
                type="text"
                ref={register({ required: true })}
                isInvalid={!!errors?.delivery?.city}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="state">
              <Form.Label>{deliveryConfig.stateLabel}</Form.Label>
              <input
                type="hidden"
                name="delivery.state"
                ref={register({ required: true })}
              />
              <Select
                options={getRegionsForCountry(deliveryCountry)}
                value={getRegion(deliveryCountry, deliveryRegion)}
                onChange={(data) => {
                  setValue('delivery.state', data?.value);
                  if (data?.value) {
                    clearErrors(['delivery.state']);
                  }
                }}
                placeholder={`Select ${deliveryConfig.stateLabel}...`}
                isDisabled={!deliveryCountry}
                styles={{
                  ...SELECT_STYLES,
                  control: (provided, state) => ({
                    ...provided,
                    backgroundColor: '#ffffff',
                    borderColor:
                      errors?.delivery?.state?.type === 'required'
                        ? 'red'
                        : '#ced4da',
                  }),
                }}
              />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="postal_code">
              <Form.Label>{deliveryConfig.postalCodeLabel}</Form.Label>
              <Form.Control
                name="delivery.postal_code"
                type="text"
                ref={register({ required: true })}
                isInvalid={!!errors?.delivery?.postal_code}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="country_code">
              <Form.Label>Country</Form.Label>
              <input
                type="hidden"
                name="delivery.country"
                ref={register({ required: true })}
              />
              <Select
                options={COUNTRIES}
                value={getCountry(deliveryCountry)}
                onChange={handleDeliveryCountrySelect}
                placeholder="Select Country..."
                styles={SELECT_STYLES}
              />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Checkbox>
              <Form.Group controlId="sameBillingAddress">
                <Form.Check
                  type="checkbox"
                  label="Same Billing Address"
                  name="same_billing"
                  ref={register}
                  checked={sameAddress}
                  onChange={handleSameAddress}
                />
              </Form.Group>
            </Checkbox>
          </Form.Row>
        </>
      )}

      {(!sameAddress || !withEssentials) && (
        <>
          <SubSectionHeader>
            <Label>Billing Address</Label>
          </SubSectionHeader>

          <Form.Row>
            <Form.Group as={Col} controlId="line1">
              <Form.Label>Street</Form.Label>
              <Form.Control
                name="billing.line1"
                type="text"
                ref={register({ required: true })}
                isInvalid={!!errors?.billing?.line1}
              />
            </Form.Group>

            <Form.Group as={Col} controlId="line2">
              <Form.Label>Suburb</Form.Label>
              <Form.Control
                name="billing.line2"
                type="text"
                ref={register}
                isInvalid={!!errors?.billing?.line2}
              />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="city">
              <Form.Label>City</Form.Label>
              <Form.Control
                name="billing.city"
                type="text"
                ref={register({ required: true })}
                isInvalid={!!errors?.billing?.city}
              />
            </Form.Group>

            <Form.Group as={Col} controlId="state">
              <Form.Label>{billingConfig.stateLabel}</Form.Label>
              <input
                type="hidden"
                name="billing.state"
                ref={register({ required: true })}
              />
              <Select
                options={getRegionsForCountry(billingCountry)}
                value={getRegion(billingCountry, billingRegion)}
                onChange={(data) => {
                  setValue('billing.state', data?.value);
                  if (data?.value) {
                    clearErrors(['billing.state']);
                  }
                }}
                placeholder={`Select ${billingConfig.stateLabel}...`}
                isDisabled={!billingCountry}
                styles={{
                  ...SELECT_STYLES,
                  control: (provided, state) => ({
                    ...provided,
                    backgroundColor: '#ffffff',
                    borderColor:
                      errors?.billing?.state?.type === 'required'
                        ? 'red'
                        : '#ced4da',
                  }),
                }}
              />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="postal_code">
              <Form.Label>{billingConfig.postalCodeLabel}</Form.Label>
              <Form.Control
                name="billing.postal_code"
                type="text"
                ref={register({ required: true })}
                isInvalid={!!errors?.billing?.postal_code}
              />
            </Form.Group>

            <Form.Group as={Col} controlId="country_code">
              <Form.Label>Country</Form.Label>
              <input
                type="hidden"
                name="billing.country"
                ref={register({ required: true })}
              />
              <Select
                options={COUNTRIES}
                value={getCountry(billingCountry)}
                onChange={handleBillingCountrySelect}
                placeholder="Select Country..."
                styles={SELECT_STYLES}
              />
            </Form.Group>
          </Form.Row>
        </>
      )}
    </>
  );
};

OrderAddress.defaultProps = {
  withEssentials: false,
  deliveryCountry: '',
  billingCountry: '',
  deliveryRegion: '',
  billingRegion: '',
};

export default OrderAddress;
